import * as React from 'react';
import { observer } from 'mobx-react';
import { T } from '../../../../../../Translations';
import { drop, take } from '@execonline-inc/collections';
import { ProductLicenseResource } from '../../../../Types';
import CompetencyLabel from '../../../CompetencyLabel';
import ExcessCompetencies from '../../../ExcessCompetencies';

interface Props {
  productLicense: ProductLicenseResource;
}

const Competencies: React.FC<Props> = ({ productLicense }) => (
  <div className="mt-5">
    <h4 className="mb-3 text-sm font-semibold text-[#202532]">
      <T kind="{{count}} Competency" count={productLicense.payload.competencies.length} />
    </h4>
    <div className="my-2 flex flex-wrap gap-x-2 gap-y-2">
      {take(4, productLicense.payload.competencies).map((competency) => (
        <CompetencyLabel competency={competency} key={competency.payload.id} />
      ))}
      <ExcessCompetencies competencies={drop(4, productLicense.payload.competencies)} />
    </div>
  </div>
);
export default observer(Competencies);
